<script lang="ts" setup>
import { useAppStore } from "@/store/app.store";
import { OrdersMixin } from "@/views/orders/mixins/orders.mixin";
import { useDateTime } from "@/composables";
import { computed } from "vue";
import type { OrderStopTimeType } from "@/constants/order";

const props = withDefaults(
  defineProps<{
    timeType: OrderStopTimeType | null;
    timeTo: string | null | undefined;
    stopTimezone: string | undefined | null;
    disabled?: boolean;
  }>(),
  {
    disabled: false,
  },
);

const appStore = useAppStore();
const orderUtils = OrdersMixin.methods!;
const { dateTZ } = useDateTime();

function getTimeWithTZ(time: string | undefined | null, timezone: string | null | undefined) {
  if (!timezone || !time) {
    return "";
  }

  return dateTZ(time, timezone);
}

const textDisabledClass = computed(() => {
  return {
    "text-grey": props.disabled,
  };
});
</script>

<template>
  <div>
    <div
      v-if="appStore.dispatcher"
      class="font-size-12 font-weight-500 text-grey-darken-3 mb-1 text-uppercase"
      data-qa="next-stop-time1"
    >
      <span v-if="props.timeType" :class="textDisabledClass">
        {{ orderUtils.getTimeType(props.timeType) }}:
        {{ getTimeWithTZ(props?.timeTo, appStore.dispatcher.timezone) }}
      </span>
    </div>

    <div class="font-size-12 text-grey-darken-1 mb-2 text-uppercase" data-qa="next-stop-time2">
      <span v-if="props.timeType" :class="textDisabledClass">
        {{ orderUtils.getTimeType(props?.timeType) }}:
        {{ getTimeWithTZ(props?.timeTo, props?.stopTimezone) }}
      </span>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
